import React from 'react';
import {Map, List} from 'immutable';
import {IconButton, Text} from '@albert-io/atomic';
import {ClassroomAssignmentSettings} from './RecipientSettings.types';
import classnames from 'classnames';

import StudentsDropdown from './StudentsDropdown.react';
import StartDateDropdown from './StartDateDropdown.react';
import DueDateDropdown from './DueDateDropdown.react';

import './classroom-table.scss';

interface ClassroomTableProps {
  selectedClassrooms: Map<string, ClassroomAssignmentSettings>;
  setSelectedClassrooms: (selectedClassrooms: Map<string, ClassroomAssignmentSettings>) => void;
  noDueDateClassIds: List<string>;
  setShowDueDateError: (showDueDateError) => void;
}

const ClassroomTable = ({
  selectedClassrooms,
  setSelectedClassrooms,
  noDueDateClassIds,
  setShowDueDateError
}: ClassroomTableProps) => {
  const handleDeleteClassroom = (classroomObj) => {
    let updatedClassrooms = selectedClassrooms;
    updatedClassrooms = selectedClassrooms.delete(classroomObj.classroomInfo.getId());
    setSelectedClassrooms(updatedClassrooms);
  };

  return (
    <>
      <div className='classroom-table__heading u-mar-b_1'>
        <Text size='m'>Classroom</Text>
        <Text size='m'>Students</Text>
        <Text size='m'>Start Date</Text>
        <Text size='m'>Due Date</Text>
      </div>
      <div className='classroom-table__wrapper'>
        {selectedClassrooms.toList().map((classroomObj) => {
          const dueDateErrorExists =
            noDueDateClassIds.includes(classroomObj?.classroomInfo.getId()) &&
            !classroomObj?.dueDate;
          setShowDueDateError(dueDateErrorExists);
          return (
            <div className='classroom-table__row'>
              <Text
                size='m'
                className='classroom-table__cell u-pad_2 u-word-break_break-word u-display_flex u-justify-content_space-between u-width_100pc u-align-items_center'
              >
                {classroomObj?.classroomInfo.getName()}
              </Text>
              <div className='classroom-table__cell classroom-table__cell-button'>
                <StudentsDropdown
                  classroomObj={classroomObj}
                  selectedClassrooms={selectedClassrooms}
                  setSelectedClassrooms={setSelectedClassrooms}
                />
              </div>
              <div className='classroom-table__cell classroom-table__cell-button'>
                <StartDateDropdown
                  classroomObj={classroomObj}
                  selectedClassrooms={selectedClassrooms}
                  setSelectedClassrooms={setSelectedClassrooms}
                />
              </div>
              <div
                className={classnames('classroom-table__cell classroom-table__cell-button', {
                  'classroom-table__cell-error-state': dueDateErrorExists
                })}
              >
                <DueDateDropdown
                  classroomObj={classroomObj}
                  selectedClassrooms={selectedClassrooms}
                  setSelectedClassrooms={setSelectedClassrooms}
                />
              </div>
              <div className='classroom-table__cell'>
                <IconButton
                  icon='times'
                  label='Remove classroom'
                  onClick={() => handleDeleteClassroom(classroomObj)}
                  variant='text'
                  size='s'
                  className='u-mar-lr_auto u-align-self_center'
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ClassroomTable;
